import { render, staticRenderFns } from "./SocialUsefulWork.vue?vue&type=template&id=24117d98&"
import script from "./SocialUsefulWork.vue?vue&type=script&lang=js&"
export * from "./SocialUsefulWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports